import React, { useState } from 'react';
import './style.scss';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';
import clsx from 'clsx';
import { useEffect } from 'react';

const HeaderBannerLandingPC = (props) => {
  const { items, autoRotation } = props?.fields;
  const { params } = props;
  const { isEliteTheme } = props;
  const allBanners = items.slice(0, 3);
  const autoRotationTime = autoRotation?.fields?.DropdownValue?.value;
  //order[0] - index of big banner
  //order[1] - index of first small banner
  //order[2] - index of second small banner
  const [order, setOrder] = useState([...Array(allBanners.length)].map((_, i) => i));

  const [isAnimate, setAnimate] = useState(false);
  const toggleClass = () => {
    setAnimate(!isAnimate);
  };

  const second_ms = autoRotationTime * 1000;

  useEffect(() => {
    let firstindex = 1;
    if (autoRotationTime > 0) {
      const interval = setInterval(() => {
        handleClick(firstindex);
        firstindex += 1;
        if (firstindex >= 2) {
          firstindex = 1;
        }
      }, second_ms);
      return () => {
        clearInterval(interval);
        firstindex = 0;
      }; // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }
  }, []);

  const handleClick = (clickedOrderIndex) => {
    toggleClass();
    if (allBanners.length === 2) {
      setOrder((prev) => [prev[1], prev[0]]);
    } else {
      const anotherSmallIndex = clickedOrderIndex === 1 ? 2 : 1;
      setOrder((prev) => [
        prev[clickedOrderIndex], //goes to main position (big image)
        prev[anotherSmallIndex], //another small banner moves (or stays) to first position
        prev[0], //main banner moves to the second position
      ]);
    }
    setTimeout(function () {
      setAnimate(false);
    }, 2000);
  };

  const bigBanner = allBanners[order[0]];
  const leftBanner = allBanners[order[1]];
  const rightBanner = allBanners[order[2]];

  const shouldRenderSmallItems = allBanners.length > 1;

  //conditional randering
  if (!bigBanner && !leftBanner && !rightBanner) return null;

  return (
    <div
      className={clsx(
        'headerBannerLanding',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        params?.Styles
      )}
    >
      <div className={`bigItem ${isAnimate ? 'animating' : ''}`}>
        {bigBanner && <BannerItem banner={bigBanner.fields} />}
      </div>
      {shouldRenderSmallItems && (
        <div className="smallItem flex-it">
          {leftBanner && <BannerItem banner={leftBanner.fields} onClick={() => handleClick(1)} />}
          {rightBanner && <BannerItem banner={rightBanner.fields} onClick={() => handleClick(2)} />}
        </div>
      )}
    </div>
  );
};

const BannerItem = ({ banner, onClick }) => {
  //constants
  const primaryButton = banner.primaryButton;
  const secondaryButton = banner.secondaryButton;
  const tertiaryButton = banner.tertiaryButton;
  //rendering
  const shouldRenderImage = !!banner?.image;
  const shouldRenderTitle = !!banner?.heading?.value;
  const shouldRenderText = !!banner?.text?.value;
  const shouldRenderPrimaryButton = !!primaryButton && primaryButton?.value?.href !== '';
  const shouldRenderSecondaryButton = !!secondaryButton && secondaryButton?.value?.href !== '';
  const shouldRenderTertiaryButton = !!tertiaryButton && tertiaryButton?.value?.href !== '';
  const shouldRenderAllButtons =
    shouldRenderPrimaryButton || shouldRenderSecondaryButton || shouldRenderTertiaryButton;
  return (
    <div className="item flex-it flex-align-item-center" onClick={onClick}>
      <div className="textPlace content">
        <div className="auto">
          {shouldRenderTitle && <RichText className="title" field={banner.heading} />}
          {shouldRenderText && <RichText className="description" field={banner.text} />}

          {shouldRenderAllButtons && (
            <div className="buttons">
              {shouldRenderPrimaryButton && (
                <Button link={primaryButton} variant="contained" color="primary" />
              )}
              {shouldRenderSecondaryButton && (
                <Button link={secondaryButton} variant="contained" color="primary" />
              )}
              {shouldRenderTertiaryButton && (
                <Button link={tertiaryButton} variant="contained" color="primary" />
              )}
            </div>
          )}
        </div>
      </div>
      {shouldRenderImage && (
        <div className="picture">
          <figure>
            <Image field={banner.image} />
          </figure>
        </div>
      )}
    </div>
  );
};

export default HeaderBannerLandingPC;
